export function AVAXPillUnit({ value = null }) {
  return (
    <span className="pointer-events-none flex h-14 w-28 flex-none flex-row items-center justify-between space-x-2 rounded-full bg-black px-4 py-1.5 text-xs text-white md:w-40 md:px-6">
      <svg
        fill="none"
        height="32"
        viewBox="0 0 32 32"
        width="32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_19_238)">
          <path
            d="M16.0002 32C7.16393 32 0.000431061 24.8365 0.000431061 16.0002C0.000431061 7.16393 7.1635 0 16.0002 0C24.8369 0 32 7.1635 32 15.9998C32 24.8361 24.8365 31.9996 16.0002 31.9996"
            fill="#FF394A"
          />
          <path
            d="M20.8347 23.2487H24.5879C25.4778 23.2487 25.9229 23.2487 26.1891 23.0765C26.4772 22.8902 26.6588 22.5779 26.6782 22.2354C26.6959 21.9188 26.4755 21.5327 26.0351 20.7606L17.8169 6.3633C17.3696 5.57953 17.1462 5.18786 16.8615 5.04206C16.5539 4.88462 16.1894 4.88418 15.8819 5.0412C15.5972 5.18656 15.3729 5.57823 14.9242 6.36114L13.0289 9.67049C12.7028 10.2399 12.5397 10.5246 12.4681 10.8248C12.39 11.1518 12.39 11.4925 12.4681 11.8195C12.5393 12.1201 12.7023 12.4048 13.028 12.9742L17.9424 21.5711C18.2728 22.1491 18.4381 22.4381 18.6641 22.6542C18.9104 22.8893 19.2093 23.0627 19.5359 23.1598C19.8356 23.2491 20.1691 23.2491 20.8351 23.2491"
            fill="white"
          />
          <path
            d="M7.44361 23.2486H11.7955C12.6936 23.2486 13.1427 23.2486 13.4097 23.0748C13.6987 22.8872 13.8798 22.5723 13.8967 22.2285C13.9126 21.9101 13.6866 21.5224 13.2345 20.7472L11.0622 17.0203C10.6158 16.2547 10.3928 15.872 10.1102 15.7288C9.80485 15.574 9.4438 15.5736 9.1384 15.728C8.85587 15.8708 8.632 16.2534 8.18468 17.0182L6.00505 20.7451C5.55126 21.5206 5.32437 21.9088 5.3399 22.2272C5.35672 22.5714 5.53789 22.8867 5.8269 23.0748C6.09434 23.2486 6.54381 23.2486 7.44318 23.2486"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_19_238">
            <rect fill="white" height="32" transform="matrix(-1 0 0 1 32 0)" width="32" />
          </clipPath>
        </defs>
      </svg>

      <div className="text-base font-bold md:text-lg">AVAX</div>
      {value ? <div>{(Math.round(value * 100) / 100).toFixed(2).replace(/\.?0+$/, '')}</div> : null}
    </span>
  )
}
